import _ from "underscore";
function uniqueHelper(list) {
  return _.uniq(list);
}

export default uniqueHelper;
